import { create } from "zustand";
import { ELEMENT_ID } from "./canva/element-id";
import { defaultElements } from "./canva/canva.const";

export interface ICOOState {
  isWhatIfCOO: boolean;
}

interface COOStore extends ICOOState {
  setIsWhatIfCOO: (isWhatIfCOO: boolean) => void;
}

export const useCOOStore = create<COOStore>((set) => ({
  elements: defaultElements,
  isWhatIfCOO: false,
  setIsWhatIfCOO: (isWhatIfCOO) => set({ isWhatIfCOO }),
}));
